import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconButton, Button, TextField, Grid, Drawer, Box } from '@mui/material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import useCartStore from '../DataRepo/CartStore'
import pkgdetail from '../Assets/images/pkhdetailinfo.png'
import offerApplied from '../Assets/animations/offerapplied.json'
import DietPlanIcon from '../Assets/images/Diet Plan Icon.png'
import lifestyleicon from '../Assets/images/Lifestyle Practices Icon.png'
import TeleIcon from '../Assets/images/Teleconsultation Icon.png'
import ChatIcon from '../Assets/images/Chat Icon.png'
import consultationIcon from '../Assets/images/Group 8844.png'
import RecipesIcon from '../Assets/images/Recipes Icon.png'
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import HerbalProductsIcon from '../Assets/images/Herbal Products Icon.png'
import Lottie from 'lottie-react';
import { profileModel, shopModel, teleConsultationModel } from '../Axios/AxiosConfig';
import { getUserDetails, getUserAcc } from '../Auth/AuthUtil';
import { toast, Zoom } from 'react-toastify';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import offerimg from '../Assets/images/offer.png'
import pauymentsuccess from '../Assets/Raw/paymentsuccess_ding.mp3';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import appointmentconfetti from '../Assets/animations/appointmentconfetti.json'
import tickimg from '../Assets/images/Group 15940 (1).png'
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ArrowBack } from "@mui/icons-material";
import axios from 'axios';
import tabsqicon from '../Assets/images/tabler-icon-square-rounded-check.png'
import success from '../Assets/animations/success lottie.json';
import teleicon from '../Assets/images/Group 15066.png'
import goalicon from '../Assets/images/tele_icon.png'
import { encryptBody } from '../Axios/Middleware'

function PackageCheckout() {

    const navigate = useNavigate()

    const [coupon, setcoupon] = useState('')

    const [showmore, setShowmore] = useState(false)

    const [open, setOpen] = useState(false);

    const [open2, setOpen2] = useState(false);

    const [open3, setOpen3] = useState(false);

    const [open4, setOpen4] = useState(false);

    const [hash, sethash] = useState('')

    const [Transcation_id, setTranscation] = useState('')

    const userDetails = getUserDetails()

    let getUserAccDetails = getUserAcc()

    const [ProfileData, setProfileData] = useState([])

    const [paymentStatus, setPaymentStatus] = useState(null);

    const [isprofileloading, setprofileloading] = useState(true)

    const [errors, setErrors] = useState({
        email: '',
        phone: ''
    });

    const holistic_care = [{
        img: DietPlanIcon,
        info: "Unlock yor personalized ",
        name: "Diet Plans"
    }, {
        img: teleicon,
        info: "Expert Health Guidance",
        name: "Teleconsultation"
    },

    {
        img: lifestyleicon,
        info: "A Smarter Path to Wellness",
        name: "Lifestyle Practices"
    },

    {
        img: goalicon,
        info: "Track, Improve, Elevate",
        name: "Health Goals Tracking"
    }];

    const handleChange = (e) => {
        const { name, value } = e.target;

        setProfileData((prevState) => ({
            ...prevState,
            [name]: value
        }));

        setErrors((prevState) => ({
            ...prevState,
            [name]: ''
        }));
    };

    const validateInputs = () => {
        let isValid = true;
        const newErrors = {};

        if (!ProfileData.email) {
            newErrors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(ProfileData.email)) {
            newErrors.email = 'Please enter a valid email';
            isValid = false;
        }

        if (!ProfileData.phone) {
            newErrors.phone = 'Phone number is required';
            isValid = false;
        } else if (!/^(?:\+91|91)?\d{10}$/.test(ProfileData.phone)) {
            newErrors.phone = 'Please enter a valid phone number';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const handleClickOpen3 = () => {
        setOpen3(true);
    };

    const handleClose3 = () => {
        setOpen3(false);
    };

    const getProfile = async (id) => {
        try {
            let res = await profileModel.get(`/Profile/${id}`);

            if (res.status === 200) {
                const profile = res?.data;

                if (profile) {
                    setProfileData(profile);
                } else {
                    setProfileData(getUserAccDetails);
                }
            }
        } catch (err) {
            console.log(err?.response?.data || "An error occurred while fetching the profile");
            setProfileData(getUserAccDetails);
        } finally {
            setprofileloading(false);
        }
    };

    const { cartItems, updateQuantity, decreaseQuantity, isCartLoading, totalPrice, deliveryCharges, getCouponDetails, Coupons, CouponDetails, setCoupon, removeItem, getCart, clearCart, emptyCart, CouponErrorDetails, setCouponError,
        setCouponDetails, CompanyCodedetails, getCompanyCoupondetails } = useCartStore();

    const PackagePricing = {
        planName: "Premium Wellness Plan",

        duration: 3,

        price: 1000,

        orgprice: 3000,

        quantity: 3,

        teleconsultationlimit: 3,

        products_discount: 5,

        info: [
            'One session free Teleconsultation',
            'Personalized Dietary Plan',
            'Unlimited Chat feature',
            'Delicious Recipes Plan',
            'One Time Prakriti Assessment',
            'Tailored Lifestyle Practices',
            // 'Digital Pulse Diagnosis'
        ]
    }

    const handleCoupon = async (event) => {
        try {
            if (coupon) {
                await AvailCoupon(coupon, 'wellness', PackagePricing?.orgprice, event)
            } else {
                setCouponError({ error: "Please enter coupon" });
            }
        }

        catch (error) {
            console.error("handleCoupon: Error applying coupon", error);
        }

    };

    const price = PackagePricing?.price * PackagePricing?.duration;

    const discount = CouponDetails?.discount || 0;

    const ringtone = new Audio(pauymentsuccess)

    const finalprice = CompanyCodedetails ?

        (CompanyCodedetails?.couponType === 'percentage'
            ? price - (price * (CompanyCodedetails?.discount / 100))
            : price - CompanyCodedetails?.cashRedeem
        ).toString()

        : CouponDetails ?

            (CouponDetails?.couponType === 'percentage'
                ? price - (price * (discount / 100))
                : price - CouponDetails?.cashRedeem
            ).toString() : price.toString()


    const initiatePayment = async () => {
        if (parseInt(finalprice) > 0) {
            if (ProfileData?.email && ProfileData?.phone) {
                try {
                    const response = await shopModel.post('/makepayment', {
                        amount: finalprice,
                        txnid: Date.now(),
                        phone: ProfileData?.phone || "123456790",
                        email: ProfileData?.email,
                        productinfo: 'Aiwell Wellness Package',
                        firstname: ProfileData?.firstname || userDetails?.UID.toString(),
                        drop_category: "creditcard",
                        enforce_paymethod: "netbanking|upi",
                    });

                    if (response.status === 200) {
                        const { hash, TranscationID } = response?.data;
                        sethash(hash);
                        setTranscation(TranscationID);
                        checkout(hash, TranscationID);
                    }
                } catch (error) {
                    console?.error('Error initiating payment:', error?.response);
                }
            } else {
                handleClickOpen3();
            }
        } else {
            addSubscription();
        }
    };

    const invokePayPage = async (type) => {
        if (validateInputs()) {
            if (parseInt(finalprice) > 0) {
                try {

                    setPaymentStatus("processing");

                    const amount = finalprice

                    const res = await shopModel.post("/api/v1/PhonePe/generate-token", encryptBody({
                        amount,
                        metaInfo: {
                            "udf1": "",
                            "udf2": "",
                        },
                    }));

                    if (!res.data) {
                        throw new Error("Token URL not received");
                    }

                    const callback = async (responseStatus) => {
                        if (responseStatus === "USER_CANCEL") {
                            console.log("Transaction canceled by the user");
                            setPaymentStatus("failure");
                            // await deleteIntiateOrderProcess();
                        } else if (responseStatus === "CONCLUDED") {
                            console.log("Transaction concluded successfully");
                            setPaymentStatus("success");
                            const { hash, TranscationID } = res?.data;
                            sethash(hash);
                            setTranscation(TranscationID);
                            await addSubscription();
                        } else {
                            console.warn("Unhandled responseStatus:", responseStatus);
                            setPaymentStatus("failure");
                        }
                    };

                    if (
                        typeof window !== "undefined" &&
                        window.PhonePeCheckout &&
                        typeof window.PhonePeCheckout.transact === "function"
                    ) {
                        window.PhonePeCheckout.transact({
                            tokenUrl: res.data.paymentUrl,
                            type,
                            callback,
                        });
                    } else {
                        console.error("PhonePeCheckout or transact method not available");
                        setPaymentStatus("failure");
                    }

                } catch (error) {
                    console.log("Error invoking PayPage:", error);
                    setPaymentStatus("failure");
                }
            } else {
                await addSubscription()
            }
        } else {
            handleClickOpen3();
        }

    };

    const handleSaveProfile = async () => {
        if (validateInputs()) {
            try {
                let res = await profileModel.post(`/Profile`, {
                    ...ProfileData,
                    UID: getUserDetails()?.UID,
                });

                if (res.status === 200) {
                    handleClose3()
                    invokePayPage('IFRAME')
                }
            }

            catch (err) {
                console.log(err?.response?.data);
            }

        }
    };

    const list = (anchor) => (
        <Box sx={{
            width: (theme) => ({
                xs: '100%',
                sm: anchor === 'top' || anchor === 'bottom' ? 'auto' : 600,
                md: anchor === 'top' || anchor === 'bottom' ? 'auto' : 550,
            }),
        }}

            role="presentation"

        // onClick={toggleDrawer(anchor, false)}
        // onKeyDown={toggleDrawer(anchor, false)}

        >

            <div className='p-5'>
                <div className=' flex' style={{ justifySelf: "flex-end" }} >
                    <IconButton onClick={toggleDrawer(anchor, false)}>
                        <CloseIcon></CloseIcon>
                    </IconButton>
                </div>

                <div className="coupon-container mb-5 mt-5">

                    <input type="text" placeholder="Enter your coupon code" className="coupon-input" onChange={(e) => {
                        setcoupon(e.target.value)
                        setCouponError(null)
                    }} />

                    <button className="apply-button" onClick={(event) => {
                        handleCoupon(event);
                    }}>
                        Apply Coupon
                    </button>
                </div>

                {CouponErrorDetails &&
                    <p className='couponError'>{CouponErrorDetails?.error}</p>
                }


                <div className='flex flex-col gap-5'>
                    {
                        Coupons?.validCoupons && Coupons?.validCoupons?.filter((e) => e?.Public).map((e) => {
                            return <div className='flex'>

                                <div id="main" style={{ borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                                    <div class="top right"></div>
                                    <div class="bottom right"></div>

                                    <div className='p-5 h-full coupon-discount-card' style={{ writingMode: "sideways-lr", textAlign: "center" }}>
                                        {e?.couponType === 'percentage' ?
                                            <p>{e?.discount}% Discount</p> :
                                            <p>Flat ₹{Number(e?.cashRedeem || 0).toFixed(2)} off</p>}
                                    </div>

                                </div>

                                <div id="main2" style={{ borderTopRightRadius: "15px", borderBottomRightRadius: "15px" }}>
                                    <div class="top left"></div>
                                    <div class="bottom left"></div>

                                    <div className='coupon-card-details flex flex-col h-full'>

                                        <div className='p-5'>
                                            <h2>Coupon Code: {e?.couponName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>
                                            <div className='mt-5 cpninfotxt'>
                                                {
                                                    e?.couponType === 'percentage' ?
                                                        <p>Get {e?.discount}% discount for transaction above ₹{Number(e?.minValue || 0).toFixed(2)}  </p> :
                                                        <p>Get Flat ₹{Number(e?.cashRedeem || 0).toFixed(2)} off for transaction above ₹{Number(e?.minValue || 0).toFixed(2)}</p>
                                                }
                                            </div>
                                        </div>

                                        <div className='p-3 mt-auto self-end w-full coupon-card-action'
                                            style={{ cursor: "pointer" }} onClick={(event) => {
                                                setCouponDetails(e)
                                                handleClickOpen4()
                                                setTimeout(() => {
                                                    handleClose4()
                                                }, 3000)
                                                toggleDrawer(anchor, false)(event)
                                            }}>
                                            <p className='text-right'>Apply</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        })
                    }

                    {
                        Coupons?.invalidCoupons && Coupons?.invalidCoupons?.filter((e) => e?.Public).map((e) => {
                            return <div className='flex'>

                                <div id="main" style={{ borderTopLeftRadius: "15px", borderBottomLeftRadius: "15px" }}>
                                    <div class="top right"></div>
                                    <div class="bottom right"></div>

                                    <div className='p-5 h-full coupon-discount-card' style={{ writingMode: "sideways-lr", textAlign: "center", backgroundColor: "#DFDFDE", color: "#A5A39D" }}>
                                        {e?.couponType === 'percentage' ?
                                            <p>{e?.discount}% Discount</p> :
                                            <p>Flat ₹{Number(e?.cashRedeem || 0).toFixed(2)} off</p>}
                                    </div>

                                </div>

                                <div id="main2" style={{ borderTopRightRadius: "15px", borderBottomRightRadius: "15px", backgroundColor: "#F4F4F4" }}>
                                    <div class="top left"></div>
                                    <div class="bottom left"></div>

                                    <div className='coupon-card-details flex flex-col h-full'>

                                        <div className='p-5'>
                                            <h2 style={{ color: "#BBBBBB" }}>Coupon Code: {e?.couponName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</h2>

                                            <div className='mt-5 cpninfotxt' style={{ color: "#C7C7C7" }}>
                                                <p>Add products worth ₹{Number(e?.minValue || 0).toFixed(2)} to avail this deal! - Your health is the best investment</p>
                                            </div>

                                        </div>

                                        <div className='p-3 mt-auto self-end w-full coupon-card-action'>
                                            <p className='text-right' style={{ color: "#A5A39D" }}>Apply</p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        })
                    }
                </div>

            </div>


        </Box>

    );

    const checkout = (hash, Transcation_id) => {
        var data = {
            key: 'Ey2EbY',
            hash: hash,
            txnid: Transcation_id,
            amount: finalprice,
            firstname: ProfileData?.firstname || userDetails?.UID.toString(),
            "drop_category": "creditcard",
            "enforce_paymethod": "netbanking|upi",
            email: ProfileData?.email,
            phone: ProfileData?.phone || "123456790",
            productinfo: 'Aiwell Wellness Package',
            surl: 'http://thirdparty.com/testresponse.php',
            furl: 'http://thirdparty.com/testresponse.php',
        };

        var handlers = {
            responseHandler: function (BOLT) {
                if (BOLT.response.txnStatus == "SUCCESS") {
                    addSubscription()
                    console.log('Your payment has been successful');
                }
                if (BOLT.response.txnStatus == "FAILED") {
                    console.log('Payment failed. Please try again.');
                    closeScript();

                }
                if (BOLT.response.txnStatus == "CANCEL") {
                    console.log('Payment failed. Please try again.');
                    closeScript();
                }
            },
            catchException: function (BOLT) {
                console.log('Payment failed. Please try again.');
                closeScript();
            }
        };


        window.bolt.launch(data, handlers);
    }

    const closeScript = () => {
        if (window.bolt) {
            try {
                window.bolt.close();
            } catch (error) {
                console.log("Error closing payment script:", error);
            }
        }
    };


    const totaldiscount = CompanyCodedetails ? (CompanyCodedetails?.couponType === 'percentage' ?
        ((price / 100) * discount).toFixed(2) : CompanyCodedetails.cashRedeem) :
        CouponDetails ?
            (CouponDetails?.couponType === 'percentage' ?
                ((price / 100) * discount).toFixed(2) : CouponDetails.cashRedeem) : 0

    const AvailCoupon = async (coupon, applicableTo, total, event) => {
        try {

            const res = await shopModel.post('/api/v1/avail-coupon', {
                coupon,
                applicableTo,
                total
            })

            if (res?.status === 200) {
                setCouponDetails(res.data)
                setCouponError(null)
                handleClickOpen4()
                setTimeout(() => {
                    handleClose4()
                }, 3000)
                toggleDrawer('right', false)(event);
                setcoupon('')
            }
        }

        catch (err) {
            setCouponError(err?.response?.data)
            console.log(err)
        }
    }

    const addSubscription = async () => {
        try {
            const res = await teleConsultationModel.post('/subscription', {
                userId: userDetails?.UID,
                planName: PackagePricing?.planName,
                transcationId: Transcation_id,
                price: price,
                teleconsultationlimit: PackagePricing?.teleconsultationlimit,
                products_discount: PackagePricing?.products_discount,
                discount: totaldiscount,
                finalPrice: Number(finalprice),
                duration: PackagePricing?.duration,
                paymentDetails: {
                    "transactionId": "123456",
                    "paymentMethod": "UPI"
                }
            })

            if (res.status === 200) {
                handleClickOpen2()
                ringtone.play()
                setCouponDetails(null)

                setTimeout(() => {
                    navigate('/PackageInfo')
                }, 2500)

            }
        }
        catch (err) {
            if (err?.response?.data?.message === 'Already Subscribed') {
                toast.info(err?.response?.data?.message, {
                    position: 'top-center',
                    limit: 1,
                    transition: Zoom,
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'dark'
                });

                navigate('/')
            }

            console.log(err);
        }
    }

    const handleClickOpen4 = () => {
        setOpen4(true);
    };

    const handleClose4 = () => {
        setOpen4(false);
    };

    useEffect(() => {
        getProfile(userDetails?.UID)
        getCompanyCoupondetails()
    }, [])

    const toggleDrawer = (anchor, open) => (event) => {

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const [couponAutoApplied, setCouponAutoApplied] = useState(false);

    useEffect(() => {
        const getCoupons = async () => {
            await getCouponDetails('wellness', price);
        };

        getCoupons();

        return () => {
            setCouponDetails(null)
        };
    }, []);

    useEffect(() => {
        if (!couponAutoApplied && Coupons?.validCoupons?.length > 0) {
            const publicCoupon = Coupons.validCoupons.find(c => c?.Public);
            if (publicCoupon) {
                setCouponDetails(publicCoupon);
                setCouponAutoApplied(true);
            }
        }
    }, [Coupons, couponAutoApplied]);


    return <div className='Packages-Checkout-page-section'>

        <nav className='flex flex-row w-full p-2' >
            <IconButton onClick={() => navigate(-1)}>
                <ArrowBack />
            </IconButton>
        </nav>

        <div>
            <div className='Packages-Checkout-section w-100'>
                <div>
                    <div>
                        <div className='flex justify-between wp-card' >
                            <p>Wellness Plan</p>
                            {/* <div style={{ padding: '5px', height: "max-content", borderRadius: "5px", color: "#3B362A", backgroundColor: "#EFEFE7" }}>
                                <p>Best Deal</p>
                            </div> */}
                        </div>

                        <div className='flex flex-col justify-center items-center gap-5'>
                            <p>Elevate your well-being with personalized support & holistic care</p>
                            <div className='ribbon-main-card'>

                                {CompanyCodedetails || CouponDetails ?
                                    <p>Just at <del>₹{Number(PackagePricing?.orgprice || 0).toFixed(2)}</del>&nbsp;&nbsp;
                                        ₹{Number(finalprice || 0).toFixed(2)}
                                    </p> :
                                    <p>Just at ₹{Number(finalprice || 0).toFixed(2)} </p>
                                }

                                <p>for {PackagePricing?.quantity} months</p>
                            </div>
                            <p className='bg-[#fdfdfd] p-1 border-2 rounded'>It Includes</p>
                        </div>



                        {/* <div className='wp-card-price-details'>
                            <p>₹ {PackagePricing?.price} / <span>month</span></p>
                            <p>for {PackagePricing?.quantity} months</p>
                        </div> */}

                        {/* <div className='wp-card-info'>
                            <p>Reset-Rebuild-Enhance</p>
                        </div> */}

                        {/* <div className='flex items-center justify-between'>

                        <div className='flex gap-5'>
                            <div>
                                <p>{PackagePricing?.planName}</p>
                                <p>{PackagePricing.duration} months</p>
                            </div>
                            <div style={{ padding: '5px', height: "max-content", borderRadius: "5px", color: "#3B362A", backgroundColor: "#8CEB8C" }}>
                                <p>Best Deal</p>
                            </div>
                        </div>

                        <div style={{ width: '2rem' }}>
                            <img src={tabsqicon} />
                        </div>

                    </div> */}

                        {/* <div className="package-arrow mt-5 flex items-center justify-evenly" style={{
                        backgroundColor: "#75623F",
                        color: "#fdfdfd"
                    }}>
                        <p>₹499</p>
                        <p><del>₹999</del></p>
                        <p>3months</p>
                    </div> */}

                        {/* <p className='mt-5'>Elevate your well-being with personalized support & holistic care</p> */}

                        <div className='pklistcontainer ml-5' >
                            {
                                holistic_care && holistic_care.map((e) => {
                                    return <div className='pkinfolist2'>
                                        <div>
                                            <img src={e.img}></img>
                                        </div>
                                        <div >
                                            <p>{e.info}</p>
                                            <p>{e.name}</p>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>


                    <div>

                        {!CouponDetails && !CompanyCodedetails &&
                            <div>
                                <div>
                                    {/* <div className='p-5'>
                                        <p>Use this coupon to</p>
                                        <div className='mt-5 cpninfotxt'>
                                            {Coupons?.validCoupons.length > 0 &&
                                                Coupons?.validCoupons[0]?.couponType === 'percentage' ?
                                                <p>Get {Coupons?.validCoupons[0]?.discount}% discount for transaction above ₹{Number(Coupons?.validCoupons[0].minValue || 0).toFixed(2)}  </p> :
                                                <p>Get Flat ₹{Number(Coupons?.validCoupons[0].cashRedeem || 0).toFixed(2)} off for transaction above ₹{Number(Coupons?.validCoupons[0].minValue || 0).toFixed(2)}</p>
                                            }
                                        </div>
                                    </div> */}


                                </div>
                                <div className='flex items-center justify-between couponsandofferscontainer mt-5' style={{ cursor: "pointer" }}
                                    onClick={toggleDrawer("right", true)}>
                                    <p>View Coupons & Offers</p>
                                    <IconButton><ChevronRightIcon /></IconButton>
                                </div>
                            </div>
                        }

                        {CouponDetails && !CompanyCodedetails &&
                            <div className="CouponAppliedContainer">
                                <div className="lottie-background">
                                    <Lottie animationData={offerApplied} />
                                </div>

                                <div className="content">
                                    <img src={offerimg} alt="Offer" />
                                    <div>
                                        <p>{CouponDetails?.couponName?.toUpperCase()} Applied</p>
                                        <p>You have saved ₹{(CouponDetails?.couponType === 'percentage' ?
                                            ((price / 100) * discount) : (CouponDetails?.cashRedeem || 0)).toFixed(2)} by applying {CouponDetails?.couponName?.toUpperCase()}</p>
                                    </div>
                                </div>


                                <IconButton style={{ alignSelf: "flex-start", justifySelf: "flex-end", marginLeft: 'auto' }} onClick={() => {
                                    setCouponDetails(null)
                                    setcoupon('')
                                }}>
                                    <HighlightOffIcon />
                                </IconButton>

                            </div>
                        }

                        {
                            CouponErrorDetails != '' &&
                            <p className='CouponErrorDetails'>{CouponErrorDetails?.error}</p>
                        }


                        <div className='Cart-total-container '>
                            <div>
                                <p>Payment details</p>
                            </div>
                            <div>

                                <div>
                                    <p>Wellness Package</p>
                                    <p>₹{Number(PackagePricing.price || 0).toFixed(2)} x {PackagePricing.quantity} months</p>
                                </div>

                                <div>
                                    <p>Sub Total</p>
                                    <p>₹{Number(price || 0).toFixed(2)}</p>
                                </div>

                                {totaldiscount > 0 &&
                                    <div>
                                        <p>Coupon Discount</p>
                                        <p>- ₹{Number(totaldiscount || 0).toFixed(2)}</p>
                                    </div>
                                }
                            </div>

                            <div>
                                <p>Total :
                                    <span> ₹{Number(finalprice || 0).toFixed(2)}</span>
                                </p>
                            </div>

                        </div>

                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                            marginTop: "auto",
                            // padding: "10px",
                            width: "100%",
                        }}>
                            <div>
                                <Button
                                    style={{

                                        textTransform: 'none',
                                        backgroundColor: '#DA6E0B',
                                        color: '#FDFDFD',
                                        border: '1px solid #DA6E0B',
                                        boxSizing: 'border-box',
                                        paddingRight: "3rem",
                                        paddingLeft: "3rem",
                                        borderRadius: "5px",
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                        padding: "10px 3rem"
                                    }}
                                    onClick={() => invokePayPage('IFRAME')}
                                >
                                    {((price) - ((price / 100) * discount)) > 0 ? 'Proceed to Pay' : 'Proceed to Confirm'}
                                </Button>
                            </div>
                        </div>


                    </div>

                </div>

                <div
                    className='explore-app mt-5 text-center w-100'
                    style={{ cursor: "pointer", width: "100%" }}
                >
                    <p>
                        Not sure about the wellness package?

                        <span onClick={() => {
                            !ProfileData?.firstname ?
                                navigate('/profile') : navigate('/')
                            localStorage.setItem('ExploreApp', JSON.stringify({ selected: true }))
                        }} className='ml-5'>
                            Explore Our App
                        </span>
                    </p>

                </div>
            </div>

        </div>

        <Drawer
            anchor={'right'}
            open={state['right']}
            onClose={toggleDrawer('right', false)}
        >
            {list('right')}
        </Drawer>

        <Dialog
            open={open3}
            onClose={handleClose3}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {"Contact details"}
            </DialogTitle>

            <DialogContent>

                <div className='mt-5'>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email"
                                variant="outlined"
                                fullWidth
                                name="email"
                                value={ProfileData?.email}
                                onChange={handleChange}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#DA6E0B',
                                        },
                                    },
                                }}
                                error={!!errors.email}
                                helperText={errors.email}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Phone"
                                variant="outlined"
                                fullWidth
                                name="phone"
                                value={ProfileData?.phone}
                                onChange={handleChange}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#DA6E0B',
                                        },
                                    },
                                }}
                                error={!!errors.phone}
                                helperText={errors.phone}
                            />
                        </Grid>
                    </Grid>
                </div>

                <p className='mt-2'
                    style={{
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 400,
                        fontSize: "12px"
                    }}
                >

                    Please fill in your email and phone number before continuing with the payment.</p>

            </DialogContent>
            <DialogActions>
                <Button

                    style={{
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: '#FDFDFD',
                        border: '1px solid #DA6E0B',
                        boxSizing: 'border-box',
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "10px"
                    }}

                    onClick={handleSaveProfile} autoFocus>
                    Save
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={open2}
            onClose={handleClose2}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className='Appointment-booked-success'>
                    <Lottie animationData={success} loop={false}></Lottie>
                    <p>Wellness Package Booked Successfully</p>
                </div>
            </DialogContent>
        </Dialog>

        <Dialog
            open={open4}
            onClose={handleClose4}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth
            PaperProps={{
                style: { borderRadius: '10px', overflow: 'hidden' }
            }}
        >
            <DialogContent className='cpndialogbg'>

                <div className="Lottie-background">
                    <Lottie animationData={appointmentconfetti}></Lottie>
                </div>

                {/* <div className='flex justify-end'>
                    <IconButton onClick={handleClose4}>
                        <CloseIcon></CloseIcon>
                    </IconButton>
                </div> */}

                <div className='flex flex-col items-center gap-3 justify-center'>

                    <img src={tickimg} style={{ width: '5rem' }}>
                    </img>

                    <div className='uploadimgreportinfo text-center'>
                        <p >Congrats!</p>
                    </div>

                    <div className='flex p-5 cpnapplied'>
                        <p>{CouponDetails?.couponName?.toUpperCase()} Coupon is Applied</p>
                    </div>

                    <div className='cpnsaved'>
                        <p>You have saved ₹{(CouponDetails?.couponType === 'percentage' ?
                            ((price / 100) * discount) : (CouponDetails?.cashRedeem || 0)).toFixed(2)}</p>
                    </div>

                </div>
            </DialogContent>
        </Dialog>

    </div>
}

export default PackageCheckout
